import { HttpClient, HttpBackend, HttpRequest, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class ApiGatewayService {
    apiGatewayBaseUrl!: string;
    private httpWithoutInterceptor!: HttpClient;

    constructor(
        environmentService: EnvironmentService,
        private http: HttpClient,
        private httpBackend: HttpBackend
    ) {
        this.apiGatewayBaseUrl = environmentService.environment['emApiGatewayURL'];
        this.httpWithoutInterceptor = new HttpClient(this.httpBackend);
    }

    getPresignedURL(file: any): Observable<any> {
      const headers = new HttpHeaders()

      return this.http.post(`${this.apiGatewayBaseUrl}/em-app/v1/similarity/manual_load/presignedurl`, file);
    }

    request<R>(req: HttpRequest<any>): Observable<HttpEvent<R>> {
        return this.httpWithoutInterceptor.request<R>(
          req.clone({
            url: `${req.url}`,
          })
        );
      }

}
